import styled from '@emotion/styled';
import { ErrorMessages } from '../../../utils/errorMessages';
import { Css, Responsive } from '../../../ui';
import { Color } from '../../../styles/Color';

interface INoResultsProps {
	title?: string;
	message?: string;
	image?: React.ReactNode;
}

export const NoResults = ({
	message,
	title = 'No results',
	image,
}: INoResultsProps) => (
	<Wrapper className="no-results">
		{image && image}
		<Title>{title}</Title>
		<p>{message || ErrorMessages.NoResults}</p>
	</Wrapper>
);

const Wrapper = styled.div`
	padding: ${Css.pxToRem(80)} 0;
	display: flex;
	justify-content: center;
	align-items: center;
	max-width: 320px;
	text-align: center;
	margin: 0 auto;
	flex-direction: column;

	svg {
		height: 100%;
		width: 100%;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		padding: ${Css.pxToRem(40)} 0;
	}
`;

const Title = styled.h4`
	color: ${Color.OnBackground};
	font-weight: 500;
	font-size: ${Css.pxToRem(32)};
	margin-bottom: ${Css.pxToRem(8)};
	margin-top: ${Css.pxToRem(24)};

	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		p {
			margin-bottom: ${Css.pxToRem(20)};
		}
	}
`;
